import { motion } from "framer-motion";

const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 48 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
  transition: { duration: 1, delay, ease: [0.16, 1, 0.3, 1] },
});

export const Products = ({ t }) => (
  <section id="machines" className="relative mx-auto max-w-[1440px] px-5 py-28 md:px-10 md:py-40" data-testid="products-section">
    <motion.p {...reveal()} className="mb-6 font-mono-spec text-[11px] uppercase tracking-[0.3em] text-[#00e5ff]" data-testid="products-kicker">
      / {t.kicker}
    </motion.p>
    <motion.h2 {...reveal()} className="font-display text-3xl font-semibold tracking-tight md:text-5xl" data-testid="products-title">
      {t.title}
    </motion.h2>

    <div className="mt-20 space-y-24 md:space-y-32">
      {t.items.map((p, i) => (
        <div
          key={p.id}
          className={`grid items-center gap-10 md:gap-16 ${p.img ? "lg:grid-cols-2" : "max-w-3xl"}`}
          data-testid={`product-${p.id}`}
        >
          {p.img && (
            <motion.div {...reveal()} className={`spotlight clipped-frame group relative ${i % 2 ? "lg:order-2" : ""}`}>
              <img
                src={p.img}
                alt={p.name}
                className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
              />
              <span className="absolute left-4 top-4 rounded-full border border-white/15 bg-slate-950/70 px-3 py-1 font-mono-spec text-[10px] uppercase tracking-[0.25em] text-[#00e5ff] backdrop-blur-md">
                {p.tag}
              </span>
            </motion.div>
          )}

          <div className={i % 2 ? "lg:order-1" : ""}>
            <motion.span {...reveal(0.05)} className="text-outline font-display text-6xl font-extrabold md:text-7xl">
              {String(i + 1).padStart(2, "0")}
            </motion.span>
            <motion.h3 {...reveal(0.1)} className="mt-4 font-display text-2xl font-semibold uppercase tracking-tight text-slate-50 md:text-4xl">
              {p.name}
            </motion.h3>
            <motion.p {...reveal(0.15)} className="mt-6 max-w-lg text-sm leading-relaxed text-slate-400 md:text-base">
              {p.desc}
            </motion.p>
            <motion.div {...reveal(0.2)} className="mt-8 flex flex-wrap gap-2">
              {p.specs.map((s) => (
                <span key={s} className="rounded border border-white/10 bg-slate-900/50 px-3 py-1.5 font-mono-spec text-[10px] uppercase tracking-[0.2em] text-slate-300">
                  {s}
                </span>
              ))}
            </motion.div>
            <motion.div {...reveal(0.25)} className="mt-8">
              <p className="font-mono-spec text-[10px] uppercase tracking-[0.3em] text-slate-500">{t.idealLabel}</p>
              <p className="mt-2 text-sm text-slate-300">{p.idealFor.join("  ·  ")}</p>
            </motion.div>
          </div>
        </div>
      ))}
    </div>
  </section>
);
